import {PlatformAPIHttpClient} from "./platform-api-http-client";

export class SellersHttpClient extends PlatformAPIHttpClient {
    public getSiteCategories = () => this.instance.get('/sellers/site-categories');
}